// ##############################
// // // SocialButtons view styles
// #############################

const SocialButtonsStyle = {
    linkLogin: {
        display: 'block',
    },
    customButtonClass: {
        '&,&:focus,&:hover': {
            color: '#FFFFFF',
            background: '#A6CE39',
        },
        '&:before': {
            content: '""',
            display: 'block',
            background: 'url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFFSURBVHgBnZM9LwRBGMef5UoJxdVsQSl3EoJoFD4AokShoFGgJ1fr9BIvnwC5UjIRNUGjvCtV7hrJyYXxGzuSMdnbnb1/8tt5ff777DM7kfSQ1rpMswbTMAhdeIF6FEVNCREmk6B0tu4hzjPagQ8drqNeRtvOpndoBBoe+EYxfDkb1mFVh2vKNbvwFo1xS4dLuVn5qlmMxryvqMJ5SszsgD36vINRNqDFcB9qcOJtmy/xmJNwjcAmjMIK7EryDxpVTGZlKa5F6MCrO2nM2lJcHW6BMRvyzZ6kuI6p3wRt7Mw9m5pdwVlO8DU0bb8OD6D8PSXSbfOWWwZLzkLF6S9LUoo7O56BU0kO408Kn8ZvD7Pxgj+pr/hfjkxs6f50KGliYQO6gSbfsCdZ0sn1uswxUlD1Y6MsU5oFW/Bh+IRHuKHYb2kxPw9sZbZPFrWrAAAAAElFTkSuQmCC\')no-repeat',
            backgroundSize: 'cover',
            width: '20px',
            height: '20px',
            position: 'absolute',
            left: '3rem',
            top: '10px'
        },
        marginLeft: '0',
        paddingTop: '4px',
        position: 'relative',
        marginRight: '0',
        padding: '0',
        textTransform: 'uppercase',
        width: '100%',
        fontWeight: '900',
        height: '40px',
        background: '#A6CE39',
        borderRadius: '0',
        fontSize: '14px',
    },

};

export default SocialButtonsStyle;



// WEBPACK FOOTER //
// ./src/containers/SocialButtons/styles.js